import { useLazyGetQuery, usePostMutation, usePutMutation } from "slices/api";

export const useLazyGetOtpAccessCodeQuery = () => {
  const [accessCode, data] = useLazyGetQuery();

  const getAccessCode = async (query = {}) => {
    return await accessCode(
      {
        endpoint: "/public-api-code/generate",
        query,
      },
    ).unwrap();
  };

  return [getAccessCode, data];
};

export const useRequestOTPMutation = () => {
  const [handleForgotPassword, data] = usePostMutation();
  const [getAccessCode] = useLazyGetOtpAccessCodeQuery();
  const forgotPassword = async (
    query = {},
    toastMessage,
    isFireSafety = false,
    isUtilityTunnel = false
  ) => {
    const accessCodeResponse = await getAccessCode();
    const authCode = accessCodeResponse?.data?.code;

    if (authCode) {
      return await handleForgotPassword({
        endpoint: isFireSafety
          ? "/firesafety-user/request-otp"
          : isUtilityTunnel
          ? "uta-card-issuance-user/request-otp"
          : "/user/request-otp",
        query: {
          ...query,
          authKey: authCode,
        },
        toastMessage,
        tags: [],
      }).unwrap();
    }
  };
  return [forgotPassword, data];
};

export const useValidateOTPPutMutation = () => {
  const [validateOTP, data] = usePutMutation();
  const handleOTP = async (
    payload,
    query = {},
    isFireSafety = false,
    isUtilityTunnel = false
  ) => {
    return await validateOTP({
      endpoint: isFireSafety
        ? "/firesafety-user/validate-otp"
        : isUtilityTunnel
        ? "uta-card-issuance-user/validate-otp"
        : "/user/validate-otp",
      query,
      payload: payload || {},
      toastMessage: "OTP verified successfully",
      tags: [],
    }).unwrap();
  };
  return [handleOTP, data];
};

export const useSetNewPasswordPutMutation = () => {
  const [handlePassword, data] = usePutMutation();
  const setNewPassword = async (
    payload,
    query = {},
    isFireSafety = false,
    isUtilityTunnel = false
  ) => {
    return await handlePassword({
      endpoint: isFireSafety
        ? "/firesafety-user/set-new-password"
        : isUtilityTunnel
        ? "/uta-card-issuance-user/set-new-password"
        : "/user/set-new-password",
      query,
      payload: payload || {},
      toastMessage: "Password changed successfully",
      tags: [],
    }).unwrap();
  };
  return [setNewPassword, data];
};
